import { QueryClientProvider } from "@tanstack/react-query";

import { queryClient } from "./context";
import type { ReactNode } from "react";

export function Provider({ children }: { children: ReactNode }) {
	return (
		<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
	);
}
